import { useItems } from "@adamlip/okeoke.client"
import { useContext, useEffect, useRef } from "react"
import { scroller } from "react-scroll"
import CategoryWrapper from "./CategoryWrapper"
import { AppParamsContext } from "contexts/AppParamsContext"
import V2CategorySelector from "views/Order/Categories/V2CategorySelector"
import V3CategorySelector from "views/Order/Categories/V3CategorySelector"

export default function CategorySelector({
  selectedCategory,
  setSelectedCategory,
}) {
  const { appParams } = useContext(AppParamsContext)
  const { categoryTree, categories } = useItems()
  const refArray = useRef([])
  const timer = useRef()
  const searchparams = new URLSearchParams(window.location.search)

  const filterFunction = (category) => {
    return (
      categories?.[category.uuid]?.enabled &&
      (category.availability?.availableItems > 0 ||
        category.availability?.availableSubItems > 0) &&
      (category.availability?.visibleItems > 0 ||
        category.availability?.visibleSubItems > 0)
    )
  }

  const scrollToElement = (e) => {
    let categUUID = e.substr(e.length - 32)
    let ref = getRefFromArray(categUUID)
    if (ref != null) ref.current.scrollIntoView({ inline: "center" })
  }

  const addRefToArray = (ref) => {
    refArray.current.push(ref)
  }

  const getRefFromArray = (id) => {
    for (let ref of refArray.current) {
      if (ref.current?.id === `categList_${id}`) return ref
    }
    return null
  }

  useEffect(() => {
    const options = {
      duration: 800,
      delay: 100,
      smooth: true,
      containerId: "orderItemList-byCategory",
      offset: 10,
    }
    if (searchparams.get("categoryUUID") != null) {
      timer.current = setTimeout(() => {
        scroller.scrollTo(
          `orderItemList-byCategory_${searchparams.get("categoryUUID")}`,
          options
        )
      }, 1000)
    }
    return () => clearTimeout(timer.current)
    // eslint-disable-next-line
  }, [categoryTree])

  if (appParams?.items?.categorySelectorType === "v2") {
    return (
      <V2CategorySelector
        categoryTree={categoryTree}
        addRefToArray={addRefToArray}
        scrollToElement={scrollToElement}
        categories={categories}
        selectedCategory={selectedCategory}
        filterFunction={filterFunction}
        setSelectedCategory={setSelectedCategory}
      />
    )
  }
  if (appParams?.items?.categorySelectorType === "v3") {
    return (
      <V3CategorySelector
        categoryTree={categoryTree}
        addRefToArray={addRefToArray}
        scrollToElement={scrollToElement}
        categories={categories}
        selectedCategory={selectedCategory}
        filterFunction={filterFunction}
        setSelectedCategory={setSelectedCategory}
      />
    )
  }
  return (
    <>
      <div className={`orderItemCategories-root orderItemCategories-root-v2 `}>
        {categoryTree.filter(filterFunction).map((category) => (
          <div
            key={category.uuid}
            className={`orderItemCategory-root orderItemCategory-root-v2`}
          >
            <CategoryWrapper
              categoryUUID={category.uuid}
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              addRefToArray={addRefToArray}
              scrollToElement={scrollToElement}
            />
            {category.categories.length > 0 &&
              category.categories.filter(filterFunction).map((subCategory) => (
                <div
                  key={subCategory.uuid}
                  className="orderItemCategory-subCategory-root orderItemCategory-subCategory-root-v2"
                >
                  <CategoryWrapper
                    categoryUUID={subCategory.uuid}
                    categories={categories}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    addRefToArray={addRefToArray}
                    scrollToElement={scrollToElement}
                  />
                </div>
              ))}
          </div>
        ))}
      </div>
    </>
  )
}
